import React, { useState } from "react";
import { Label, TextInput, Spinner } from "flowbite-react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";
import Mousetrap from "mousetrap";

import "./Create.css";

const backend = await new Backend().init();

export default function Create({ updateType }) {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [name, setName] = useState("");

  const onCreate = () => {
    if (username == "") {
      toast.error("Invalid Username ");
    } else if (name == "") {
      toast.error("Invalid Name ");
    } else {
      setLoading(true);
      let data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        user_username: username,
        user_name: name,
      };

      backend.create_super(data).then((r) => {
        setLoading(false);
        if (r.error == "False") {
          toast.success(r.message);
          updateType(2)
          setUsername("");
          setName("");
        } else {
          toast.error(r.message);
        }
      });
    }
  };

  Mousetrap.bind("enter", function () {
    Mousetrap.unbind("enter");
    onCreate();
  });

  return (
    <div className="createUser">
      <div className="username">
        <div style={{ marginBottom: 10 }}>
          <Label className="label" value="Username" />
        </div>

        <input
          type="text"
          name="search"
          id="search"
          autoComplete="new-password"
          placeholder="Enter Username"
          class="input hover-background bg-gray-50 border h-8 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
          value={username}
          onChange={(e) => {
            setUsername(e.target.value);
          }}
        />
      </div>
      <div className="name">
        <div style={{ marginBottom: 10 }}>
          <Label className="label" value="Name" />
        </div>

        <input
          type="text"
          name="search"
          id="search"
          autoComplete="new-password"
          placeholder="Enter Name"
          class="input hover-background bg-gray-50 border h-8 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
      </div>
      <div onClick={onCreate} className=" btnSubmit">
        {loading ? <Spinner size="sm" /> : "Submit"}
      </div>
    </div>
  );
}
